import { reasonsBankTransactionConstants } from "../../../actions/precog/reasonsBankTransaction";

const defaultState = {
  status: {
    started: false,
    saving: false,
    error: false,
    ended: false
  },
  list: []
};

export function reasonsBankTransaction(state = defaultState, { type, payload, error }) {
  switch (type) {
  case reasonsBankTransactionConstants.GET_ACCOUNTING_REASONS_START:
    return {
      ...state,
      status: {
        started: true,
        saving: false,
        error: false,
        ended: false
      }
    };

  case reasonsBankTransactionConstants.GET_ACCOUNTING_REASONS_SUCCESS:
    return {
      ...state,
      status: {
        started: false,
        saving: false,
        error: false,
        ended: true
      },
      list: payload
    };

  case reasonsBankTransactionConstants.GET_ACCOUNTING_REASONS_ERROR:
    return {
      ...state,
      status: {
        started: false,
        saving: false,
        error: true,
        ended: true
      }
    };
  case reasonsBankTransactionConstants.CLEAR_ACCOUNTING_REASONS:
    return defaultState;
  default:
    return state;
  }
}
